<template>
  <!-- 院校管理 -->
  <div class="page">
    <div
      class="paginations"
      :style="{ filter: this.$store.state.isVague ? 'blur(2px)' : '' }"
    >
      <div class="table-search-box table-search-box-hander">
        <el-form :inline="true" :model="searchData" class="demo-form-inline">
          <!-- 防止输入框回车刷新页面 -->
          <el-form-item label="" v-show="false">
            <el-input></el-input>
          </el-form-item>
          <el-form-item label="资源库名称：">
            <el-input
              size="small"
              v-model="searchData.zykname"
              placeholder="请输入资源库名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="项目类型：">
            <el-select
              size="small"
              v-model="searchData.projectType"
              clearable
              filterable
            >
              <el-option
                v-for="item in projectTypeList"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报告类型：">
            <el-select
              size="small"
              v-model="searchData.reportType"
              clearable
              filterable
            >
              <el-option
                v-for="item in reportTypeList"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间：">
            <el-input
              size="small"
              v-model="searchData.yearOrMonth"
              placeholder="请输入时间"
            ></el-input>
          </el-form-item>
          <el-form-item label="级别：">
            <el-select size="small" v-model="searchData.level" clearable>
              <el-option
                v-for="item in levelList"
                :key="item.value"
                :value="item.value"
                :label="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div class="search_button">
              <i class="pointer el-icon-search" @click="search()"></i>
              <i class="pointer el-icon-refresh-left" @click="reset"></i>
            </div>
          </el-form-item>
          <div class="addition">
            <el-button @click="add">
              添加
              <i class="h_icon icon-add"></i>
            </el-button>
            <el-button @click="opencopy">
              复制
              <i class="h_icon icon-add"></i>
            </el-button>
          </div>
        </el-form>
      </div>

      <div class="table_box">
        <el-table
          :data="tableObj.list"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <el-table-column prop="index" label="序号" align="center">
          </el-table-column>
          <el-table-column prop="zykname" label="资源库名称" align="center">
          </el-table-column>
          <el-table-column prop="zyknum" label="资源库编号" align="center">
          </el-table-column>
          <el-table-column prop="reportType" label="报告类型" align="center">
          </el-table-column>
          <el-table-column
            prop="projectTypeName"
            label="项目类型"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="yearOrMonth" label="年份或月份" align="center">
          </el-table-column>
          <el-table-column
            prop="oneLineText"
            label="国家端封面第一行文字"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="twoLineText"
            label="国家端封面第二行文字"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="threeLineText"
            label="国家端封面第三行文字"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="fourLineText"
            label="国家端封面第四行文字"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="fiveLineText"
            label="国家端封面第五行文字（日期）"
            align="center"
          >
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <i
                class="el-icon-document"
                title="生成封面"
                @click="createCover(scope.row)"
              ></i>
              <i
                class="icona icon-edit"
                title="编辑"
                @click="edit(scope.row)"
              ></i>
              <i
                class="icona icon-delete"
                title="删除"
                @click="cutOut(scope.row.id)"
              ></i>
            </template>
          </el-table-column>
        </el-table>
        <pageNumber
          :paginations="7"
          :pageNum="searchData.pageDto.pageNum"
          :isPageSizes="true"
          :page-size="searchData.pageDto.pageSize"
          :total="tableObj.total"
          :jumpTo="tableObj.jumpTo"
          @currentChange="search"
        ></pageNumber>
      </div>
    </div>

    <!-- 添加弹窗 -->
    <el-dialog
      :title="uploadBox.title"
      :visible.sync="uploadBox.show"
      :close-on-click-modal="false"
      class="pop_up"
      append-to-body
      :before-close="handleClose"
      @opened="opened"
    >
      <el-form
        ref="uploadBox"
        :model="uploadBox.data"
        :rules="uploadBox.rules"
        label-width="208px"
      >
        <el-form-item
          v-for="(item, index) in formItemGroup"
          :key="index"
          :label="item.label"
          :prop="item.prop"
        >
          <el-input
            v-if="item.option === 'input'"
            size="small"
            v-model="uploadBox.data[item.prop]"
            :placeholder="item.placeholder"
          ></el-input>
          <el-input
            v-if="item.option === 'textarea'"
            size="small"
            type="textarea"
            v-model="uploadBox.data[item.prop]"
            :placeholder="item.placeholder"
          ></el-input>
          <el-date-picker
            v-if="item.option === 'datetime'"
            size="small"
            :type="item.type"
            :placeholder="item.placeholder"
            v-model="uploadBox.data[item.prop]"
            :clearable="false"
            style="width: 100%"
            :value-format="item.type === 'year' ? 'yyyy' : 'yyyyMM'"
            popper-class="dateClass"
          ></el-date-picker>
          <el-radio-group
            v-if="item.option === 'radio'"
            v-model="uploadBox.data[item.prop]"
            @input="radioChange"
          >
            <el-radio
              v-for="(key, value) in item.radioList"
              :key="value"
              :label="key.label"
            >
              {{ key.name }}
            </el-radio>
          </el-radio-group>
          <el-select
            v-if="item.option === 'select'"
            v-model="uploadBox.data[item.prop]"
            :placeholder="item.placeholder"
            :popper-append-to-body="false"
            size="small"
            style="width: 100%"
            filterable
            :clearable="item.clearable"
            @change="selectChange($event, item.prop)"
          >
            <el-option
              v-for="(obj, i) in item.selectList"
              :key="i"
              :label="obj.name"
              :value="obj.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="tx-center">
        <el-button size="small" @click="submitUpload">确定</el-button>
        <el-button size="small" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageNumber from "@/components/pageNumber.vue"; //分页
export default {
  components: {
    pageNumber,
  },
  data() {
    return {
      // 查询条件
      searchData: {
        zykname: "",
        projectType: "",
        reportType: "",
        yearOrMonth: "",
        type: "",
        level: "",
        pageDto: {
          pageNum: 1, //当前显示的页面页码数
          pageSize: 10,
        },
      },
      // 级别
      levelList: [
        {
          value: 1,
          name: "国家级",
        },
        {
          value: 2,
          name: "省级",
        },
        {
          value: 3,
          name: "校级",
        },
      ],
      reportTypeList: [
        {
          value: 1,
          name: "年度",
        },
        {
          value: 2,
          name: "月度",
        },
        {
          value: 3,
          name: "个性化年度报告",
        },
        {
          value: 4,
          name: "季度报告",
        },
        {
          value: 5,
          name: "半年报",
        },
        {
          value: 6,
          name: "整体报告",
        },
        {
          value: 7,
          name: "课程质量报告",
        },
        {
          value: 8,
          name: "专业大数据季度报告",
        },
        {
          value: 9,
          name: "国家端专业资源库季报",
        },
        {
          value: 10,
          name: "国家端专业资源库半年报",
        },
        {
          value: 11,
          name: "国家端专业资源库年报",
        },
        {
          value: 12,
          name: "在线精品课视频公开课季报",
        },
        {
          value: 13,
          name: "在线精品课视频公开课半年报",
        },
        {
          value: 14,
          name: "在线精品课视频公开课年报",
        },
        {
          value: 15,
          name: "在线精品课视频公开课报告",
        },
        {
          value: 16,
          name: "国家端整体月报",
        },
        {
          value: 17,
          name: "国家端整体季报",
        },
        {
          value: 18,
          name: "国家端整体半年报",
        },
        {
          value: 19,
          name: "国家端整体年报",
        },
        {
          value: 20,
          name: "国家端对比分析报告",
        },
        {
          value: 21,
          name: "国家端月度区间报告",
        },
        {
          value: 22,
          name: "国家端资源库月报",
        },
      ], //项目类型
      projectTypeList: [
        {
          value: "1",
          name: "资源库",
        },
        {
          value: "2",
          name: "在线放开课",
        },
        {
          value: "3",
          name: "视频公开课",
        },
        {
          value: "4",
          name: "国家端报告",
        },
      ], //报告类型
      // 表格数据
      tableObj: {
        total: 0,
        jumpTo: 1,
        list: [],
      },
      optId: "", //判断当前是修改还是新增操作  1-新增；2-修改
      // 新增弹窗
      uploadBox: {
        show: false,
        title: "",
        data: {
          id: null,
          courseName: "", //课程名称
          yearOrMonth: "", //月份或者年份
          level: "1", //级别
          zykid: "", //资源库id
          zykname: "", //资源库名
          type: "", //报告类型
          projectType: "", //项目类型
          oneLineText: "", //国家端封面第一行文字
          twoLineText: "", //国家端封面第二行文字
          threeLineText: "", //国家端封面第三行文字
          fourLineText: "", //国家端封面第四行文字
          fiveLineText: "", //国家端封面第五行文字（日期）
          filePath: "",
          timeType: "",
          quarter: "",
          halfYear: "",
        },
        rules: {
          name: [
            { required: true, message: "请输入学校名称", trigger: "blur" },
          ],
        },
      },
      formItemGroup: [
        {
          option: "select",
          prop: "projectType",
          label: "项目类型",
          placeholder: "请选择",
          selectList: [],
          clearable: true,
        },
        {
          option: "select",
          prop: "type",
          label: "报告类型",
          placeholder: "请选择",
          selectList: [],
          clearable: true,
        },
        {
          option: "radio",
          prop: "level",
          label: "级别",
          radioList: [
            {
              name: "国家级",
              label: "1",
            },
            {
              name: "省级",
              label: "2",
            },
          ],
        },
        {
          option: "select",
          prop: "zykid",
          label: "资源库",
          placeholder: "请选择",
          selectList: [],
          clearable: true,
        },
        {
          option: "input",
          prop: "courseName",
          label: "课程名称",
          placeholder: "请输入",
        },
        {
          option: "select",
          prop: "timeType",
          label: "时间类型",
          placeholder: "请选择",
          selectList: [
            { value: "year", name: "年份" },
            { value: "halfYear", name: "半年份" },
            { value: "month", name: "月份" },
            { value: "quarter", name: "季度" },
          ],
        },
        {
          option: "datetime",
          prop: "yearOrMonth",
          type: "year",
          label: "年份",
          placeholder: "选择年份",
        },
        {
          option: "input",
          prop: "filePath",
          label: "文件路径",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "oneLineText",
          label: "国家端封面第一行文字",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "twoLineText",
          label: "国家端封面第二行文字",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "threeLineText",
          label: "国家端封面第三行文字",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "fourLineText",
          label: "	国家端封面第四行文字",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "fiveLineText",
          label: "国家端封面第五行文字（日期）",
          placeholder: "请输入",
        },
      ],
      zykDataList: [],
      multipleSelection: [],
      tableHeight: "",
    };
  },
  watch: {
    "specialtyBox.data.filterText"(val) {
      this.$refs.specialtyTree.filter(val);
    },
  },
  created() {
    this.search();
  },
  mounted() {
    // 初始化
    this.uploadBox.show = false;
    this.$store.commit("modifyVague", false);
    this.formItemGroup.find((item) => item.prop === "type").selectList =
      this.reportTypeList;
    this.formItemGroup.find((item) => item.prop === "projectType").selectList =
      this.projectTypeList;
  },
  methods: {
    // 切换 国家级/省级 单选按钮
    radioChange(value) {
      this.uploadBox.data.zykid = "";
      this.source(value);
    },
    // 获取资源库
    source(value) {
      this.$axios
        .post(this.$apiurls.major_getAllZykList, value, { loading: false })
        .then((res) => {
          if (res.data) {
            for (const item of res.data) {
              item.name = item.zykName;
              item.value = item.zykId;
            }
            this.zykDataList = res.data;
            this.formItemGroup.find(
              (item) => item.prop === "zykid"
            ).selectList = this.zykDataList;
          }
        });
    },
    // 切换时间
    selectChange(val, type) {
      if (!type) return;
      if (type === "timeType") {
        let yearOrMonth = this.formItemGroup.find(
          (item) => item.prop === "yearOrMonth"
        );
        let index = this.formItemGroup.findIndex(
          (item) => item.type === "detailTime"
        );
        this.uploadBox.data.yearOrMonth = "";
        if (val === "month") {
          yearOrMonth.type = "month";
          yearOrMonth.label = "月份";
          yearOrMonth.placeholder = "选择月份";
        } else {
          yearOrMonth.type = "year";
          yearOrMonth.label = "年份";
          yearOrMonth.placeholder = "选择年份";
        }
        if (val === "quarter") {
          let obj = {
            option: "select",
            prop: "quarter",
            label: "季度",
            type: "detailTime",
            placeholder: "请选择",
            selectList: [
              { value: "第一季度", name: "第一季度" },
              { value: "第二季度", name: "第二季度" },
              { value: "第三季度", name: "第三季度" },
              { value: "第四季度", name: "第四季度" },
            ],
          };

          if (index === -1) this.formItemGroup.splice(6, 0, obj);
          else this.formItemGroup[index] = obj;
        } else if (val === "halfYear") {
          let obj = {
            option: "select",
            prop: "halfYear",
            label: "半年份",
            type: "detailTime",
            placeholder: "请选择",
            selectList: [
              { value: "上半年", name: "上半年" },
              { value: "下半年", name: "下半年" },
            ],
          };
          if (index === -1) this.formItemGroup.splice(6, 0, obj);
          else this.formItemGroup[index] = obj;
        } else if (index !== -1) this.formItemGroup.splice(index, 1);
      } else if (type === "zykid") {
        let obj = { zykId: "", zykName: "", zykNum: "" };
        if (val) obj = this.zykDataList.find((item) => item.value === val);
        this.uploadBox.data.zykid = obj.zykId;
        this.uploadBox.data.zykname = obj.zykName;
        this.uploadBox.data.zyknum = obj.zykNum || "";
      }
    },
    // 动态渲染表格的高度
    renderTableHeight() {
      this.tableHeight =
        document.getElementsByClassName("table_box")[0].offsetHeight - 40;
    },
    // 查询表格
    search(obj = {}) {
      this.searchData.pageDto.pageNum = obj.page ? obj.page : 1;
      this.searchData.pageDto.pageSize = obj.limit ? obj.limit : 10;
      this.tableObj.jumpTo = obj.page ? obj.page : 1;
      this.searchData.type = this.searchData.reportType
        ? this.searchData.reportType
        : 0;
      this.$axios
        .post(this.$apiurls.getLv2ReportFile, this.searchData, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            for (let i = 0; i < res.data.list.length; i++) {
              if (this.searchData.pageDto.pageNum == 1) {
                res.data.list[i].index = i + 1;
              } else {
                res.data.list[i].index =
                  i +
                  1 +
                  (this.searchData.pageDto.pageNum - 1) *
                    this.searchData.pageDto.pageSize;
              }
              res.data.list[i].status =
                res.data.list[i].status == 0 ? false : true;
            }
            res.data.list.forEach((item) => {
              let type = this.reportTypeList.find(
                (obj) => obj.value == item.type
              );
              if (type) item.reportType = type.name;
              let projectType = this.projectTypeList.find(
                (obj) => obj.value == item.projectType
              );
              if (projectType) item.projectTypeName = projectType.name;
            });
            this.tableObj.list = res.data.list;
            this.tableObj.total = res.data.total;
          }
        });
    },
    // 重置表格
    reset() {
      this.searchData.zykname = "";
      this.searchData.projectType = "";
      this.searchData.reportType = "";
      this.searchData.yearOrMonth = "";
      this.searchData.level = "";
      this.search();
    },
    // 点击生成封面按钮
    createCover(row) {
      let params = {
        id: row.id,
        one: row.oneLineText,
        two: row.twoLineText,
        three: row.threeLineText,
        four: row.fourLineText,
        five: row.fiveLineText,
      };
      this.$axios
        .get(this.$apiurls.getReportBg, { params }, { loading: false })
        .then((res) => {
          if (res.data)
            this.$message({
              message: "生成成功！",
              type: "success",
            });
          else
            this.$message({
              message: "生成失败！",
              type: "error",
            });
        });
    },
    // 点击编辑按钮
    edit(row) {
      this.optId = "2";
      this.uploadBox.title = "修改报告";
      this.uploadBox.show = true;
      this.$store.commit("modifyVague", true);
      if (row.type == 0) row.type = "";
      if (row.yearOrMonth) {
        if (row.yearOrMonth.length === 4) this.uploadBox.data.timeType = "year";
        else if (row.yearOrMonth.indexOf("季度") != -1) {
          this.uploadBox.data.timeType = "quarter";
          this.uploadBox.data.quarter = row.yearOrMonth.slice(4, 8);
          row.yearOrMonth = row.yearOrMonth.slice(0, 4);
        } else if (row.yearOrMonth.indexOf("半年") != -1) {
          this.uploadBox.data.timeType = "halfYear";
          this.uploadBox.data.halfYear = row.yearOrMonth.slice(4, 7);
          row.yearOrMonth = row.yearOrMonth.slice(0, 4);
        } else this.uploadBox.data.timeType = "month";
        this.selectChange(this.uploadBox.data.timeType, "timeType");
      }
      if (row.zyknum) row.level = "1";
      else row.level = "2";
      this.source(row.level);
      for (const key in row) {
        this.uploadBox.data[key] = row[key];
      }
    },
    // 点击删除按钮
    cutOut(id) {
      this.$store.commit("modifyVague", true);
      this.$confirm("此操作将永久删除该报告, 是否继续?", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          this.$axios
            .post(
              this.$apiurls.delLv2ReportFile,
              { id },
              {
                loading: false,
              }
            )
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  message: "删除成功！",
                  type: "success",
                });
                this.search();
              }
              this.uploadBox.show = false;
              this.$store.commit("modifyVague", false);
            });
        })
        .catch(() => {
          this.uploadBox.show = false;
          this.$store.commit("modifyVague", false);
        });
    },
    // 点击新增按钮
    add() {
      // 每次新增打开弹框前都先清除之前的表单数据
      for (const key in this.uploadBox.data) {
        if (key === "id") this.uploadBox.data[key] = null;
        else if (key !== "level") this.uploadBox.data[key] = "";
      }
      this.optId = "1";
      this.uploadBox.title = "添加报告";
      this.uploadBox.show = true;
      this.uploadBox.data.level = "1";
      this.source("1");
      this.$store.commit("modifyVague", true);
    },
    // 点击复制按钮
    opencopy() {
      if (this.multipleSelection.length === 0)
        return this.$message({
          message: "请先选择要复制的行！",
        });

      this.$prompt("输入报告时间：", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          this.$axios
            .post(
              this.$apiurls.insertLv2ReportFile,
              { List: this.multipleSelection, yearOrMonth: value },
              { loading: false }
            )
            .then((res) => {
              if (res.code == 200)
                this.$message({
                  message: "复制成功！",
                  type: "success",
                });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    // 表格多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 关闭弹框
    handleClose() {
      this.uploadBox.show = false;
      this.$store.commit("modifyVague", false);
      this.optId = "";
    },
    // 添加/修改院校请求接口
    submitUpload() {
      this.$refs.uploadBox.validate((valid) => {
        if (valid) {
          let url =
            this.optId === "1"
              ? this.$apiurls.addLv2ReportFile
              : this.optId === "2"
              ? this.$apiurls.edLv2ReportFile
              : "";
          this.uploadBox.data.type = this.uploadBox.data.type
            ? this.uploadBox.data.type
            : 0;
          if (this.uploadBox.data.timeType === "quarter")
            this.uploadBox.data.yearOrMonth =
              this.uploadBox.data.yearOrMonth + this.uploadBox.data.quarter;
          else if (this.uploadBox.data.timeType === "halfYear")
            this.uploadBox.data.yearOrMonth =
              this.uploadBox.data.yearOrMonth + this.uploadBox.data.halfYear;
          if (!url) return;
          this.$axios
            .post(url, this.uploadBox.data, {
              loading: false,
            })
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: this.optId === "2" ? "编辑成功！" : "添加成功！",
                  type: "success",
                });
                this.search();
              }
              this.uploadBox.show = false;
              this.$store.commit("modifyVague", false);
              this.optId = "";
            });
        }
      });
    },
    // 弹框打开
    opened() {
      // 每次打开弹框都清空校验
      this.$refs.uploadBox.clearValidate();
    },
  },
};
</script>

<style lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style lang="scss" src="@/assets/css/tableList.scss" scoped></style>
<style lang="scss" scoped>
.paginations {
  height: 100%;
}
.el-form {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  .addition {
    margin-top: 5px;
  }
}

// 分配专业
.distribute ::v-deep .el-dialog__body {
  padding: 10px 20px 20px;
}
.distributionBox {
  max-height: 500px;
  overflow-y: auto;
  margin-bottom: 10px;
}
.specialty_box {
  height: 470px;
  overflow-y: auto;
  // background: #a5a4bf;
  margin-bottom: 60px;
  margin-right: 20px;
}
.specialty_bottom {
  position: absolute;
  bottom: -45px;
  right: 38%;
}
.el-tree,
::v-deep.el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content,
::v-deep.el-tree-node:focus > .el-tree-node__content {
  background: transparent;
  color: #c0c4cc;
}

.el-tree ::v-deep .el-tree-node__content:hover {
  background: #203058 !important;
  color: #fff;
}

.table_box {
  // max-height: calc(100% - 60px);
  margin-bottom: 0;
}
</style>
<style lang="scss">
.el-select-dropdown {
  position: absolute;
  z-index: 1001;
  border: none !important;
  max-height: 268px;
  border-radius: 4px;
  background-color: rgba(26, 38, 72);
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  box-sizing: border-box;
  margin: 5px 0;
  .el-select-dropdown__list {
    box-sizing: border-box;
    padding: -1px 0;
    background: rgba(26, 38, 72) !important;
    .el-select-dropdown__item {
      color: #fff !important;
    }
    .hover,
    .el-select-dropdown__item:hover {
      background: transparent;
      border: 1px solid rgba(27, 246, 248);
    }
    .el-select-dropdown__item:hover span {
      font-size: 14px;
      transform: scale(1);
    }
    .selected {
      color: rgba(27, 246, 248);
    }
  }
  .popper__arrow,
  .popper__arrow::after {
    position: absolute;
    display: "";
    width: "";
    height: "";
    border: none;
    border-style: "";
  }
}
.el-input__inner {
  background: rgba(86, 94, 121, 0.59);
  border-color: rgba(86, 94, 121, 0.59);
  color: #fff;
}
.el-icon-document {
  font-size: 18px;
  color: #1bf6f8;
  margin-right: 5px;
  cursor: pointer;
}
</style>
